module.exports = __webpack_public_path__ + "static/img/lALPD3zUNOeeljjNAUvNA24_878_331.aa345ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lALPD3zUNOeeljjNAUvNA24_878_331.png
// module id = RPvN
// module chunks = 0